<template>
  <ChartWidget
    :title="$t('message.dashboard.widgetTitle.queries')"
    :tooltip="$t('message.dashboard.widgetTooltip.queries')"
    :dataset="dataset"
    :loading="loading"
    :action-handler="actionHandler"
  ></ChartWidget>
</template>

<script>
import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";
import ChartWidget from "@/components/Dashboard/base/ChartWidget";
import { RATING_CHART_COLOR } from "@/config/rating-chart-colors";

export default {
  name: "DashboardQueriesWidget",
  components: {
    ChartWidget
  },
  mixins: [dashboardWidget],
  data() {
    return {
      dataset: []
    };
  },
  watch: {
    data() {
      this.createDataset();
    }
  },
  methods: {
    createDataset() {
      const getValues = key => ({
        name: this.$t(`message.dashboard.queriesSerie.${key}`),
        value: this.data[key].value.count,
        percentage: this.data[key].value.percentage,
        increase: this.data[key].change
      });

      this.dataset = [
        {
          ...getValues("direct"),
          color: RATING_CHART_COLOR.RATING_5
        },
        {
          ...getValues("indirect"),
          color: RATING_CHART_COLOR.RATING_4
        },
        {
          ...getValues("chain"),
          color: RATING_CHART_COLOR.RATING_1
        }
      ];
    }
  }
};
</script>
